import { render, staticRenderFns } from "./LegalTermsAutoInfracao.vue?vue&type=template&id=2d4ca11c&scoped=true&"
import script from "./LegalTermsAutoInfracao.vue?vue&type=script&lang=js&"
export * from "./LegalTermsAutoInfracao.vue?vue&type=script&lang=js&"
import style0 from "./LegalTermsAutoInfracao.vue?vue&type=style&index=0&id=2d4ca11c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d4ca11c",
  null
  
)

export default component.exports